import { ChevronRight, PlaneTakeoff } from 'lucide-react';

interface Props {
  active: boolean;
  onImport: () => void;
  onExplore: () => void;
}

export function CTASlide({ active, onImport, onExplore }: Props) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-8">
      {/* App icon */}
      <div
        className="relative mb-10"
        style={{ animation: active ? 'ob-hero-pop 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) both' : undefined }}
      >
        <div
          className="w-24 h-24 rounded-[24px] bg-gradient-to-br from-accent/20 to-accent/5 flex items-center justify-center backdrop-blur-sm border border-accent/20"
          style={{ animation: active ? 'ob-glow-pulse 3s ease-in-out infinite' : undefined }}
        >
          <PlaneTakeoff size={40} strokeWidth={1.5} className="text-accent" />
        </div>
        {/* Ambient glow */}
        <div
          className="absolute inset-0 -z-10 rounded-[24px] blur-[40px]"
          style={{ background: 'radial-gradient(circle, var(--color-accent) 0%, transparent 70%)', opacity: 0.15 }}
        />
      </div>

      {/* Text */}
      <h1
        className="text-[32px] leading-tight font-extrabold text-slate-100 mb-3 text-center"
        style={{ animation: active ? 'ob-slide-up 0.6s ease-out 0.3s both' : undefined }}
      >
        Ready to fly?
      </h1>
      <p
        className="text-[15px] text-slate-400 text-center max-w-[280px] leading-relaxed mb-10"
        style={{ animation: active ? 'ob-slide-up 0.6s ease-out 0.5s both' : undefined }}
      >
        Import your roster and connect with your crew in seconds.
      </p>

      {/* CTAs */}
      <div className="w-full max-w-[300px]" style={{ animation: active ? 'ob-slide-up 0.6s ease-out 0.7s both' : undefined }}>
        <button
          onClick={onImport}
          className="w-full flex items-center justify-center gap-2.5 py-4 rounded-2xl bg-accent text-white font-bold text-base active:scale-[0.96] transition-all mb-3"
          style={{ boxShadow: '0 8px 32px rgba(140,106,46,0.25), 0 2px 8px rgba(0,0,0,0.2)' }}
        >
          Import My Roster
          <ChevronRight size={20} />
        </button>
        <button
          onClick={onExplore}
          className="w-full text-center text-sm text-slate-500 hover:text-slate-300 transition-colors py-2"
        >
          Explore first
        </button>
      </div>
    </div>
  );
}
